import * as React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../store';
import { trainingActionCreators } from '../../store/Training';
import { ServicePanelVisibility, TrainingCard } from '../../types/TrainingTypes';

const servicePanelVisibilityTextes: [ServicePanelVisibility, string][] = [
    [ServicePanelVisibility.Always, 'Always'],
    [ServicePanelVisibility.RecallAndOnMistake, 'On mistake'],
];

export default function ServicePanelVisibilityDropdown(props: { card: TrainingCard }) {
    const dispatch = useAppDispatch();
    const servicePanelVisibility = useAppSelector(state => state.training).servicePanelVisibility;

    function onServicePanelVisibilityChange(visibility: ServicePanelVisibility) {
        dispatch(trainingActionCreators.setServicePanelVisibility(visibility));
    }

    return (
        <Dropdown className="d-inline-block panel-btn">
            <Dropdown.Toggle variant="outline-light"
                className="btn-sm" >
                Choice card actions: {servicePanelVisibilityTextes.find(x => x[0] === servicePanelVisibility)?.[1]}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {servicePanelVisibilityTextes.map(([key, value]) =>
                    <Dropdown.Item as={Button}
                        key={key}
                        variant="outline"
                        active={key === servicePanelVisibility}
                        onClick={() => onServicePanelVisibilityChange(key)}>
                        {value}
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
}
